export const capitalizeFirstLetter = (
  text: string | null | undefined
): string => {
  if (!text) return "-";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const capitalizeEachWord = (text: string | null | undefined): string => {
  if (!text) return "-";
  return text
    .split(" ")
    .map((word) => capitalizeFirstLetter(word))
    .join(" ");
};
